/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {getUserNameFromString} from '../../../services/common';
import defaultUserImg from '../../../assets/images/required/user.png';


class ModalInvitedDeclined extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center call-video',
    });
  }

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  render() {
    const data = this.props.data || {};
    const userName = data.name;
    const userPhoto = data.photoUrl || defaultUserImg;
    const name = getUserNameFromString(userName, true);

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <h3 className="logout-title">Отклонение приглашения на видеосессию</h3>
            <div className="send-panel-inner">
              <div className="text-call intro">Пользователь отклонил приглашение на видеосессию.</div>
              <div className="send-name">
                <div className="text-call">Пользователь:</div>
                <div className="image-wrap">
                  <div className="user-image">
                    <img src={userPhoto} alt={name} />
                  </div>
                </div>
                {name}
              </div>
            </div>
            <div className="btn-wrap">
              <button
                onClick={this.onCancelClick}
                className="btn btn-base"
                style={{width: '200px'}}
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalInvitedDeclined.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ModalInvitedDeclined);
